module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Sketch-9b58e80d029cea9079df03c5f9408f83.svg";